import { render, staticRenderFns } from "./bankCard.vue?vue&type=template&id=a74e0d3c&scoped=true&"
import script from "./bankCard.vue?vue&type=script&lang=js&"
export * from "./bankCard.vue?vue&type=script&lang=js&"
import style0 from "./bankCard.vue?vue&type=style&index=0&id=a74e0d3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74e0d3c",
  null
  
)

export default component.exports